import { render } from "./ImageSlider.vue?vue&type=template&id=2def9eb9&scoped=true"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"

import "./ImageSlider.vue?vue&type=style&index=0&id=2def9eb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2def9eb9"]])

export default __exports__